import React, { useEffect } from 'react';
import styled from 'styled-components';

import Modal from '~/atomic/molecula/Modal';
import { PageTitleStyle } from '~/atomic/Typography';
import { QuickAuthForm } from '~/feature/authorization/quickAuth/QuickAuthForm';
import { DEFAULT_CONFIRM_METHOD } from '~/feature/authorization/quickAuth/QuickAuthPhoneForm';
import { subscribeBookModalSelector } from '~/feature/book/SubscribeBookModal/subscribeBookModal.selector';
import {
  subscribeBookModalActions,
  subscribeBookModalSliceName,
} from '~/feature/book/SubscribeBookModal/subscribeBookModal.slice';
import { ym } from '~/feature/yandex/YandexMetrikaInit';
import { lessThan } from '~/lib/mediaQuery';
import { useAppDispatch, useAppSelector } from '~/store';

export const AuthModalWithSubscribeBook = () => {
  const dispatch = useAppDispatch();
  const { isOpenAuthModalWithSubscribeBook } = useAppSelector(subscribeBookModalSelector);

  useEffect(() => {
    if (isOpenAuthModalWithSubscribeBook) {
      ym('reachGoal', 'open-auth-modal');
    }
  }, [isOpenAuthModalWithSubscribeBook]);

  const closeModal = () => {
    dispatch(subscribeBookModalActions.setIsOpenAuthModalWithSubscribeBook(false));
  };

  const afterAuthHandler = (available: boolean) => {
    if (available) {
      dispatch(subscribeBookModalActions.setIsOpenRegisterModalWithSubscribeBook(true));
    } else {
      dispatch(subscribeBookModalActions.setIsOpenLoginModalWithSubscribeBook(true));
    }

    closeModal();
  };

  const afterPhoneAuthHandler = () => {
    closeModal();
    dispatch(subscribeBookModalActions.changeConfirmPhoneMethodWithSubscribeBook(DEFAULT_CONFIRM_METHOD));
  };

  return (
    <SCAuthModal
      onCancel={closeModal}
      open={isOpenAuthModalWithSubscribeBook}
    >
      <SCTitle>Авторизуйтесь для чтения книги</SCTitle>
      <QuickAuthForm
        closeModal={closeModal}
        afterAuth={afterAuthHandler}
        afterPhoneAuth={afterPhoneAuthHandler}
        queries={[{ name: subscribeBookModalSliceName, value: 'true' }]}
      />
    </SCAuthModal>
  );
};

const SCTitle = styled.h2`
  ${PageTitleStyle};
  margin-bottom: 37px;
  text-align: center;
`;

const SCAuthModal = styled(Modal)`
  max-width: 458px;
  
  ${lessThan('xs')} {
    max-width: 100vw;
    top: 0;
  }
`;
